import React from 'react';
import { Button } from 'react-bootstrap';
import { HeaderTitle } from 'components/UserProfile';
import useUserStore from 'store/user';
import { S3_URL } from 'constants';
import useTranslate from 'hooks/useTranslate';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player';
import './styles.scss';

const ResumeVideoBox: React.FC<any> = ({ onShowModal, isSelf, handleDeleteResume, type }: any) => {
	const { translate } = useTranslate();
	const { profileData: { videoResume = '' } = {} }: any = useUserStore((state) => state);

	return (
		<div className="video-resume-box white-box bg-white">
			<HeaderTitle
				title={translate('Profile.videoResume')}
				onShowModal={onShowModal}
				type="editVideoResume"
				isEdit={true}
			/>
			<div className="video-resume-box-inner">
				<div className="video-resume-box-inner-preview d-flex justify-content-between gap-2 gap-sm-3">
					<div className="flex-1">
						{videoResume && (
							<div className="video-preview position-relative mb-3">
								<div
									style={{
										width: '100%',
										height: '100%',
										cursor: 'pointer',
										position: 'relative',
										zIndex: 1,
									}}
									onClick={() => onShowModal('videoPlayer')}
								>
									<div className="video-overlay h-100 w-100 d-flex align-items-center justify-content-center position-absolute top-0 start-0">
										<Button className="edit-btn rounded-circle p-0 border-0 bg-transparent text-white">
											<i className="ri-play-fill"></i>
										</Button>
									</div>

									<ReactPlayer url={`${S3_URL}${videoResume}`} width="100%" height="100%" />
								</div>
							</div>
						)}
						{!videoResume && (
							<h4 className="mb-0 d-flex gap-2 video-resume-box-inner-title align-items-center">
								<Link to="">
									<i className="ri-attachment-2"></i>
								</Link>
								{translate('Profile.resume')}
							</h4>
						)}
					</div>

					{isSelf && (
						<div className="d-flex gap-2 gap-sm-3">
							<Button
								className="edit-btn rounded-circle p-0 border-0"
								onClick={() => onShowModal('editVideoResume')}
							>
								<i className="ri-eye-line"></i>
							</Button>

							{videoResume && (
								<Button
									className="edit-btn rounded-circle p-0 border-0"
									onClick={() => handleDeleteResume(type)}
								>
									<i className="ri-delete-bin-line"></i>
								</Button>
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default ResumeVideoBox;
